<template>
    <div class="centerx">
        <vs-popup class="history-service-detail" title="Service list" :active.sync="popupServiceConfig.isOpen">
            <div class="bg-custom" style="height: 100%; overflow-y: auto; padding: 20px">
                <div v-if="popupServiceConfig.item_info.check_in">
                    <div v-if="popupServiceConfig.item_info.check_in.services.length != 0">
                        <vx-card class="mb-5 overflow-hidden md:p-0 p-5" v-for="(service, index) in popupServiceConfig.item_info.check_in.services" :key="index">
                            <template slot="no-body">
                                <div class="item-details no-gutter p-6 flex align-center">
                                    {{service.name}}
                                </div>
                            </template>
                        </vx-card>
                    </div>
                    <div class="text-center text-lg" v-else>
                        No service
                    </div>
                </div>
                <!-- <div v-if="popupServiceConfig.item_info.check_in.services.length > 0">
                    <vs-pagination class="mt-6" :total="parseInt(serviceData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination>
                </div> -->
            </div>
        </vs-popup>
    </div>
</template>

<script>
    export default {
        name: 'history-service-detail',
        props: {
            popupServiceConfig: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                currentPage: 1,
                itemsPerPage: 10
            }
        },
        watch:{
            popupServiceConfig: {
                immediate: true,
                deep: true,
                handler() {
                    if(this.popupServiceConfig.isOpen) {
                    document.body.classList.add('overflow-hidden');
                    document.body.style.position = '';
                    document.body.style.top = '';
                    window.scrollTo(0, parseInt(scrollY || '0') * -1);
                    } else {
                    document.body.classList.remove('overflow-hidden');
                    }
                }
            }
        },
        computed:{
          serviceData(){
            return this.$store.state.serviceList.checkoutServiceData;
          },
          serviceList(){
            return this.$store.state.serviceList.checkoutService;
          }
        },
        // methods: {
        //     changePage(currentPage, itemsPerPage) {
        //       const obj = {
        //           page: currentPage,
        //           "per-page": itemsPerPage,
        //       }
        //       this.$store.dispatch("serviceList/GET_SERVICE_LIST", obj)
        //     }
        // },
        // created() {
        //     const obj = {
        //         page: this.currentPage,
        //         "per-page": this.itemsPerPage
        //     }
        //     this.$store.dispatch("serviceList/GET_SERVICE_LIST", obj);
        // }
    }
</script>

<style lang="scss">
    .con-vs-popup {
        &.history-service-detail {
            z-index: 90000 !important;
           .vs-popup {
                width: 600px;
                height: auto;
                .vs-popup--content {
                    width: auto;
                    height: 400px;

                    // max-height: calc(100vh - 200px);
                    // min-height: calc(100vh - 600px);
                    margin-right: 0;
                    .bg-custom {
                      background: #fafafa;
                    }
                }
           }
        }
    }
</style>
